// The five pillars of the Commercial Excellence strategy (DEC-2026-09-23-01), mirrored from
// Scout.Domain/Pillars.cs so a chip can name one without a round trip. The API remains the source:
// /scout/pillars lists them with the measurements under each.

export const PILLAR_NAMES: Record<string, string> = {
  discipline: 'BD education and discipline',
  accounts: 'Account management',
  analytics: 'Commercial data analytics and reporting',
  'enablement-sales': 'Sales enablement',
  'enablement-ops': 'Enablement — AI, PPP India, US team',
}

/** The name the deck uses for a pillar key; the key itself when the API sends one this build does not know. */
export function pillarName(key: string | null | undefined): string | null {
  if (!key) return null
  return PILLAR_NAMES[key] ?? key
}
